import { render } from "./OrderDetail.vue?vue&type=template&id=131ef922&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"

import "./OrderDetail.vue?vue&type=style&index=0&id=131ef922&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131ef922"]])

export default __exports__